<div class="container">
  <mat-card>
    @if (editUserForm) {
      <form [formGroup]="editUserForm" (ngSubmit)="submit()">
        <mat-card-content>
          <div class="layout-row-wrap gap-2px responsive-column">
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Username' | translate }}</mat-label>
              <input matInput required formControlName="username" readonline />
              @if (editUserForm.controls.username.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Username' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Email' | translate }}</mat-label>
              <input matInput required formControlName="email" />
              @if (editUserForm.controls.email.hasError('email')) {
                <mat-error>
                  {{ 'labels.inputs.Email' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.invalid' | translate }}</strong>
                </mat-error>
              }
              @if (editUserForm.controls.email.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Email' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.First Name' | translate }}</mat-label>
              <input matInput required formControlName="firstname" />
              @if (editUserForm.controls.firstname.hasError('pattern')) {
                <mat-error>
                  {{ 'labels.inputs.First Name' | translate }}
                  <strong>{{ 'labels.commons.cannot begin with a special character or number' | translate }}</strong>
                </mat-error>
              }
              @if (editUserForm.controls.firstname.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.First Name' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Last Name' | translate }}</mat-label>
              <input matInput required formControlName="lastname" />
              @if (editUserForm.controls.lastname.hasError('pattern')) {
                <mat-error>
                  {{ 'labels.inputs.Last Name' | translate }}
                  <strong>{{ 'labels.commons.cannot begin with a special character or number' | translate }}</strong>
                </mat-error>
              }
              @if (editUserForm.controls.lastname.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Last Name' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-20">
              <mat-label>{{ 'labels.inputs.Code' | translate }}</mat-label>
              <mat-select formControlName="countryCode" required>
                @for (country of countryCodes; track country) {
                  <mat-option [value]="country.code">
                    {{ 'countries.' + country.key | translate }} ({{ country.code }})
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-75">
              <mat-label>{{ 'labels.inputs.Phone Number' | translate }}</mat-label>
              <input matInput formControlName="phoneNumber" required maxlength="12" minlength="4" />
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Gender' | translate }}</mat-label>
              <mat-select formControlName="gender" required>
                <mat-option value="GENDER_MALE">{{ 'labels.catalogs.male' | translate }}</mat-option>
                <mat-option value="GENDER_FEMALE">{{ 'labels.catalogs.female' | translate }}</mat-option>
                <mat-option value="GENDER_OTHER">{{ 'labels.catalogs.other' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Language' | translate }}</mat-label>
              <mat-select formControlName="preferredLanguage" required>
                @for (lang of languageCodes; track lang) {
                  <mat-option [value]="lang.code">
                    {{ 'languages.' + lang.key | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
              <mat-select required formControlName="officeId" (selectionChange)="officeChanged($event.value)">
                @for (office of officesData; track office) {
                  <mat-option [value]="office.id">
                    {{ office.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Staff' | translate }}</mat-label>
              <mat-select formControlName="staffId">
                @for (staff of staffData; track staff) {
                  <mat-option [value]="staff.id">
                    {{ staff.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Roles' | translate }}</mat-label>
              <mat-select formControlName="roles" multiple>
                @for (rol of rolesData; track rol) {
                  <mat-option [value]="rol.id">
                    {{ rol.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-card-actions class="layout-row align-center gap-5px responsive-column">
              <button type="button" mat-raised-button [routerLink]="['../']">
                {{ 'labels.buttons.Cancel' | translate }}
              </button>
              <button mat-raised-button color="primary">
                {{ 'labels.buttons.Submit' | translate }}
              </button>
            </mat-card-actions>
          </div>
        </mat-card-content>
      </form>
    }
  </mat-card>
</div>
